const APP_TIMEOUT_MINUTES = 120 ;
export const APP_TIMEOUT = 60 * 1000 * APP_TIMEOUT_MINUTES ;

// These are the constants which define what sort of question is to be rendered in the Communications Plan form
export const CommsPlanSectionTypes = {
  TEXTAREA: 1,
  MESSAGING: 2,
  LIFESTORY: 3,
  INPUT: 4,
  TOGGLE: 5,
};

export const CommsPlanStatusValues = {
  DRAFT: 1,
  REVIEW: 2,
  APPROVED: 3,
  ENDED: 5,
};

export const UserTypes = {
  ADMIN: 1,
  ARC_MANAGER: 2,
  ORG_MANAGER: 3,
  ARC_COORDINATOR: 4,
  FOSTER_PARENT: 5,
  FOREVER_PARENT: 6,
  CHILD: 7,
  PROFESSIONAL: 8,
  LIFE_STORY_WORKER: 9,
  BIRTH_PARENT: 10,
  OTHER: 11,
  CONNECTED_CARER: 12,
  ORG_STAFF: 13,
  ALL: 999
};

export const UserStatus = {
  ACTIVE: 4,
  ARCHIVED: 7
};

/**
 * Enum for family_type IDs as defined in the family_types database table
 *
 * @readonly
 *
 * @enum {FamilyTypes}
 */
export const FamilyTypes = {
  BIRTH : 1,
  FOSTER : 2,
  FOREVER : 3,
  ADOPTER : 3,
  FRIENDS : 4,
  PETS : 5
}

export const UserGroupTypes =
{
  USER_GROUP_STAFF: 1
};

export const UserRights = {
  IS_LETTERBOX_ADMIN: 7,
  IS_LETTERBOX_APPROVER: 8,
};

export const UserTypeFilters = {
  STAFF: 'staff',
  CHILDREN: 'children',
  FOSTER_CARERS: 'fosterCarers',
  FOREVER_PARENTS: 'foreverParents',
  CONNECTED_CARERS: 'connectedCarers',
  BIRTH_PARENTS: 'birthParents',
  PROFESSIONALS: 'professionals',
  OTHERS: 'others',
  MY_CONTRIBUTORS: 'mycontributors',
  ARCHIVED: 'archived',
  BLOCKED: 'blocked'
}

export const UserTypeTitles = {
  STAFF: 'Staff',
  CHILDREN: 'Children',
  FOSTER_CARERS: 'Foster Carers',
  FOREVER_PARENTS: 'Adopters',
  CONNECTED_CARERS: 'Connected Carers',
  BIRTH_PARENTS: 'Birth Parents',
  PROFESSIONALS: 'Professionals',
  OTHERS: 'Others',
  MY_CONTRIBUTORS: 'Contributors',
  ARCHIVED: 'Archived (Deleted) Users',
  BLOCKED: 'Blocked Users'
}

export const UserTypeName = {
  ORGANISATION_MANAGER: 'Organisation Manager',
  LIFESTORY_WORKER: 'Lifestory Worker',
  CHILD: 'Child',
  FOSTER_CARER: 'Foster Carer',
  FOREVER_PARENT: 'Adopter',
  CONNECTED_CARER: 'Connected Carer',
  BIRTH_PARENT: 'Birth Parent',
  PROFESSIONAL: 'Professional',
  OTHER: 'Other'
}

/////////////
//  Families
/////////////
export const FamilyMemberType = {
  FAMILY_MEMBER_FATHER: 1,
  FAMILY_MEMBER_MOTHER: 2,
  FAMILY_MEMBER_BROTHER: 4,
  FAMILY_MEMBER_SISTER: 5,
  FAMILY_MEMBER_GRANDFATHER: 6,
  FAMILY_MEMBER_GRANDMOTHER: 7,
  FAMILY_MEMBER_UNCLE: 8,
  FAMILY_MEMBER_AUNTIE: 9,
  FAMILY_MEMBER_NEPHEW: 10,
  FAMILY_MEMBER_NIECE: 11,
  FAMILY_MEMBER_COUSIN: 12,
  FAMILY_MEMBER_FRIEND: 13,
  FAMILY_MEMBER_PET: 14,
  FAMILY_MEMBER_FAMILY_FRIEND: 15,
  FAMILY_MEMBER_OTHER_FAMILY: 16,
  FAMILY_MEMBER_OTHER: 17,
  FAMILY_MEMBER_GUARDIAN: 18,
}

export const FamilyMemberGroup = {
  FAMILY_MEMBER_GROUP_PARENTS: 1,
  FAMILY_MEMBER_GROUP_SIBLINGS: 2
}

/////////////
//  Roles
/////////////
export const ChildRoles = {
  EDITOR: 1,
  MANAGER: 2,
  CONTRIBUTOR: 3,
  MESSAGER: 4
};

export const UserRoleGroups = {
  CAN_BE_EDITOR: [UserTypes.ORG_MANAGER,
    UserTypes.ORG_STAFF,
    UserTypes.FOSTER_PARENT,
    UserTypes.FOREVER_PARENT,
    UserTypes.LIFE_STORY_WORKER,
    UserTypes.CONNECTED_CARER,
    UserTypes.ARC_MANAGER,
    UserTypes.ARC_COORDINATOR,
    UserTypes.ADMIN],
  CAN_BE_MANAGER: [UserTypes.ORG_MANAGER,
    UserTypes.FOSTER_PARENT,
    UserTypes.FOREVER_PARENT,
    UserTypes.LIFE_STORY_WORKER,
    UserTypes.CONNECTED_CARER,
    UserTypes.ARC_MANAGER,
    UserTypes.ARC_COORDINATOR,
    UserTypes.ADMIN],
  CAN_BE_STAFF: [UserTypes.ORG_MANAGER,
    UserTypes.LIFE_STORY_WORKER,
    UserTypes.ORG_STAFF],
  CAN_BE_RELATION: [
    UserTypes.FOSTER_PARENT,
    UserTypes.FOREVER_PARENT,
    UserTypes.BIRTH_PARENT,
    UserTypes.CHILD,
    UserTypes.OTHER
  ],
  CAN_HAVE_COMMS_PLAN: [
    UserTypes.FOSTER_PARENT,
    UserTypes.FOREVER_PARENT,
    UserTypes.BIRTH_PARENT,
    UserTypes.OTHER,
    UserTypes.CHILD,
  ],
  HAS_ADDRESS_MANAGED: [
    UserTypes.FOSTER_PARENT,
    UserTypes.FOREVER_PARENT,
    UserTypes.BIRTH_PARENT,
    UserTypes.OTHER
  ],
  CAN_ASSIGN_RESOURCES:[
    UserTypes.PROFESSIONAL
  ]
}

/////////////
//  Messages
/////////////
export const MessageType = {
  MESSAGE_TYPE_ALL: 0,
  MESSAGE_TYPE_LIFESTORY: 1,
  MESSAGE_TYPE_MESSAGE: 2,
}

export const MessageTypeFilters = {
  MESSAGE_TYPE_ALL: 'all',
  MESSAGE_TYPE_LIFESTORY: 'lifestory',
  MESSAGE_TYPE_MESSAGE: 'message',
}

export const MessageTypeTitles = {
  MESSAGE_TYPE_ALL: 'All',
  MESSAGE_TYPE_LIFESTORY: 'Lifestory Posts',
  MESSAGE_TYPE_MESSAGE: 'Messages',
}

export const MessageStatus = {
  NEW: 1,
  APPROVED: 2,
  ARCHIVED: 3,
  RETURNED: 4,
  PENDING: 5,
  NOT_SENT: 6
}

export const MessageReadStatus = {
  UNREAD: 0,
  READ: 1
}

// Message Filters
//
// ** NOTE ** All of these have corresponding values in the MessageNew.php
//
// ** DO NOT ** make changes here without reflecting them in the PHP environment

export const MessageFilters = {
  DEFAULT: 'all',
  NEW: 'new',
  INCOMING: 'incoming', /* Is there a difference between incoming and new?? Steve - Yes this includes returned messages and poulates the 'inbox*/
  SENT: 'sent',
  DRAFT: 'draft',

  /* Steve - we need to clarify the difference between an email status and an approval status */
  /* SENT and APPROVED ar different things ...... how do POSTS work ? */
  /* These seem to be approval statuses, which are different to DRAFT / NEW / SENT */
  RETURNED: 'returned',
  PENDING: 'pending', /* ??? */
  DISCUSSING: 'discussing', /* ??? */
  APPROVED: 'approved',
  HELD: 'held',
  ALL: 'all',

  /*  BOTH: Used as a filter between two users to indicate ALL messages in both directions      */
  /*        between two users will be returned.                                                 */
  /*                                                                                            */
  /*        This functionality is used in the monitoring Private Messaging function requested   */
  /*        by Leeds and there's a separate function in MessageNew:: getFilteredMessagesForUser */
  /*        to deal with this specific use case                                                 */
  /*                                                                                            */
  BOTH: 'both' //
}

export const MessageMenuTitles = {
  DEFAULT: 'New',
  NEW: 'New',
  INCOMING: 'Inbox', /* Is there a difference between incoming and new?? Steve - Yes this includes returned messages and poulates the 'inbox*/
  SENT: 'Sent',
  DRAFT: 'Drafts',

  /* Steve - we need to clarify the difference between an email status and an approval status */
  /* SENT and APPROVED ar different things ...... how do POSTS work ? */

  /* These seem to be approval statuses, which are different to DRAFT / NEW / SENT */
  RETURNED: 'Returned to Sender',
  PENDING: 'To Approve', /* ??? */
  DISCUSSING: 'Returned to Sender', /* ??? */
  APPROVED: 'Approved',
  ALL: 'All My Messages',
}

export const MessageSource = {
  SENDER: 1,
  LETTERBOX: 2
}

/////////////
//  Posts
/////////////
export const PostStatus = {
  NEW: 1,
  APPROVED: 2,
  HELD: 3,
  RETURNED: 4,
  PENDING: 5,
  NOT_SENT: 6,
  SENT: 'sent',
  INCOMING: 'incomming'
}

export const PostFilters = {
  DEFAULT: 'new',
  NEW: 'new',
  PENDING: 'pending',
  ARCHIVED: 'archived',
  DISCUSSING: 'discussing',
  HELD: 'held',
  APPROVED: 'approved',
  RETURNED: 'returned',
  ALL: 'all',
  DRAFT: 'draft',
  SENT: 'sent', //added for child login
  INCOMING: 'incomming' // Added for child login
}

export const PostMenuTitles = {
  DEFAULT: 'Approved',
  NEW: 'To Approve',
  ARCHIVED: 'Archived',
  DISCUSSING: 'Returned',
  HELD: 'Held Back',
  APPROVED: 'Approved',
  RETURNED: 'Returned to Sender',
  ALL: 'All Posts',
  DRAFT: 'Drafts',
  SENT: 'Sent',
  INCOMING: 'Inbox'
}

/////////////
//  Letterbox
/////////////
export const LetterBoxDecision = {
  UNAPPROVED: 1,                    /* Newly created and not yet actioned */
  APPROVED_AND_FORWARDED: 2,        /* Has been approved by inbox team and sent on to recipient - this is a closure state */
  RETURN_TO_SENDER: 3,              /* Has been rejected by editor to go back to letterbox team*/
  UNAPPROVED_RETURNED_BY_EDITOR: 4, /* Message jas been returned to sender */
  APPROVED_NOT_FORWARDED: 5,        /* Has been approved but has not yet been marked as sent on */
  NOT_APPROVED: 6                   /* Document type letterbox item has been marked as not approved - this is a closure state */
}

export const LetterBoxType = {
  MESSAGE: 1,
  BIRTHDAY_CARD: 2,
  CHRISTMAS_CARD: 3,
  SETTLING_IN_LETTER: 4,
  VOICE_MESSAGE: 5
}

// *** NOTE *** - These are Mirrored in LetterboxItem.php for the server side. if you change this, be sure to modify the PHP
export const LetterBoxFilter = {
  ALL: 'all',
  UNAPPROVED: 'unprocessed',
  RETURNED_BY_LETTERBOX: 'returnedtosender',
  RETURNED_BY_EDITOR: 'returnedbyeditor',
  TO_SEND_ON: 'to_send',
  APPROVED: 'approved',
  NOT_APPROVED: 'notapproved'
}

export const LetterBoxMenuTitles = {
  ALL: 'All',
  UNAPPROVED: 'To Approve',
  APPROVED: 'To Send On',
  NOT_APPROVED: 'Not Approved',
  RETURNED: 'Returned to Sender',
  SENT: 'Approved (Sent On)',
  CALENDAR: 'Calendar'
}

/////////////
//  Resources
/////////////
export const ResourceType = {
  ALL: 0,
  FEELINGS: 5,
  LEARNING: 2,
  GAME: 1,
  HELP: 3,
}

export const ResourceTypeFilters = {
  ALL: 'all',
  FEELINGS: 'feelings',
  LEARNING: 'learning',
  GAME: 'game',
  HELP: 'help',
}

export const ResourceMenuTitles = {
  ALL: 'All Resources',
  FEELINGS: 'Feelings',
  LEARNING: 'Learning',
  GAME: 'Games',
  HELP: 'Help',
}

/////////////
//  Queues
/////////////
export const QueueType = {
  QUEUE_TO_APPROVE_INCOMING: 1,
  QUEUE_INDIVIDUAL: 2,
  QUEUE_LETTERBOX: 3,
  QUEUE_TO_APPROVE_OUTGOING: 4,
}

/////////////
//  Dashboard
/////////////
export const ChildDashboardFilters = {
  LOGINS: 'logins',
  POSTS_RECIEVED: 'posts-received',
  POSTS_SENT: 'posts-sent',
  MESSAGES_RECIEVED: 'messages-received',
  MESSAGES_SENT: 'messages-sent',
  DIARY: 'diary'
}

export const OrgDashboardFilters = {
  CHILD_POSTS: 'child-posts',
  STAFF_POSTS: 'staff-posts',
  ALL_POSTS: 'all-posts',
  CHILD_MESSAGES: 'child-messages',
  STAFF_MESSAGES: 'staff-messages',
  ALL_MESSAGES: 'all-messages',
  CHILD_LOGINS: 'child-logins',
  STAFF_LOGINS: 'staff-logins',
  ALL_LOGINS: 'all-logins',
  CHILD_DIARY: 'child-diary',
  CHILD_AGE: 'child-age',
  USERS: 'users',
}

export const SafeguardingFilters = {
  DEFAULT: 'all',
  MISUSE: 'misuse',
  BLOCKED_USERS: 'blocked'
}

export const SafeguardingMenuTitles = {
  DEFAULT: 'All',
  MISUSE: 'Misuse Reports',
  BLOCKED_USERS: 'Blocked Users'
}

export const PrivateMessagingMenuTitles = {
  DEFAULT: 'User Messages',
}

/////////////
//  Icons & Images
/////////////
export const IconPath = {
  ICON_DOCUMENT:'/images/btns/document.svg',
  ICON_MESSAGE_REPLY:'/images/icons/child/reply.png',
  ICON_MESSAGE_DELETE:'/images/icons/child/delete.png',
  ICON_MESSAGE_EDIT:'/images/icons/child/edit-text.png',
  ICON_PDF:'/images/icons/child/pdf.jpg',
  ICON_SOUNDFILE:'/images/btns/soundfile.png'
}

export const ImagePath = {
  IMAGE_DEFAULT_PERSON:'/images/defaultPerson.jpg',
  IMAGE_NO_IMAGE:'/images/noImageIncluded.png',
  IMAGE_POST_DOC:'/images/defaultPostImage.png',
}

export const ImageType = {
  IMAGE_PERSON: 1,
  IMAGE_FAMILY:2,
  IMAGE_RESOURCE: 3,
}

/////////////
//  Navigation
/////////////
export const HomePageTabs = {
  HOME: 'home',
  TEAM: 'team',
  CHILDREN: 'children',
}

/////////////
//  Translate
/////////////
export const translatePostFilter = (filter) =>
{
  let filterValue = 0;

  switch(filter){
    case 'new':
      filterValue = PostStatus.NEW;
      break;

    case 'approved':
      filterValue = PostStatus.APPROVED;
      break;

    case 'held':
      filterValue = PostStatus.PENDING;
      break;

    case 'draft':
      filterValue = PostStatus.NOT_SENT;
      break;

    case 'discussing':
      filterValue = PostStatus.RETURNED;
      break;

    case 'archived':
      filterValue = PostStatus.HELD;
      break;

    case 'sent':
      filterValue = PostStatus.SENT;
      break;

    case 'incomming':
      filterValue = PostStatus.INCOMING;
      break;

    default:
      filterValue = 'all';
  }

  return filterValue;
}

export const translateMessageFilter = (filter) =>
{
  let filterValue = 0;

  switch(filter){
    case 'new':
      filterValue = MessageStatus.NEW;
      break;

    case 'approved':
      filterValue = MessageStatus.APPROVED;
      break;

    case 'discussing':
      filterValue = MessageStatus.RETURNED;
      break;

    case 'draft':
      filterValue = MessageStatus.NOT_SENT;
      break;

    case 'sent':
      filterValue = MessageFilters.SENT;
      break;

    default:
      filterValue = 'all';
  }

  return filterValue;
}